import Button from '@/shared/components/Button';
import {Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography} from '@mui/material';
import {LastTransactionsStyle} from './LastTransactions.style';
import {ReactComponent as ArrowRight} from '@icons/arrow-right-blue.svg';
import {billingHistory} from '@/pages/Organization/Profile/Billing/History/BillingHistory.style';
import {MMMM_D_YYYY} from '@/utils/constants';
import {ReactComponent as PdfIcon} from '@/assets/icons/pdf-icon.svg';
import {IAdminTransactionData} from '@/utils/types/superAdmin.interface';
import dayjs from 'dayjs';
import {currencyFormatter} from '@/utils/helpers/currency';
import {useNavigate} from 'react-router-dom';
import { AdminPaymentStatus } from '@/utils/types';

const StatusColor: Record<AdminPaymentStatus, string> = {
  Paid: 'var(--success-600)',
  Pending: 'var(--warning-600)',
  Failed: 'var(--error-600)',
  Refunded: 'var(--neutral-600)',
};

const LastTransactions = ({transactions}: {transactions: IAdminTransactionData[]}) => {
  const navigate = useNavigate();
  return (
    <Box sx={LastTransactionsStyle.mainWrapper}>
      <Box sx={LastTransactionsStyle.headWrapper}>
        <Typography sx={LastTransactionsStyle.heading}>Last transactions</Typography>
        <Box>
          <Button
            onClick={() => navigate('/admin/profile/billing')}
            sx={LastTransactionsStyle.AllButton}
            variant="text"
            title="See all"
            endIcon={<ArrowRight />}
          />
        </Box>
      </Box>
      <TableContainer sx={LastTransactionsStyle.tableContainer}>
        <Table sx={{minWidth: 650}} aria-label="enhanced table">
          <colgroup>
            <col style={{width: '50%'}} />
            <col style={{width: '50%'}} />
            <col style={{width: 'min-content'}} />
            <col style={{width: 'min-content'}} />
            <col style={{width: 'min-content'}} />
          </colgroup>
          <TableHead>
            <TableRow>
              <TableCell>Invoice</TableCell>
              <TableCell>Billing admin</TableCell>
              <TableCell>Amount</TableCell>
              <TableCell>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {transactions.map((row, index) => (
              <TableRow key={index}>
                <TableCell sx={billingHistory.tableCell}>
                  <Box sx={[billingHistory.fileWrap, billingHistory.tableCell]}>
                    <Box sx={billingHistory.iconWrap}>
                      <PdfIcon />
                    </Box>
                    <Box>
                      <Typography sx={billingHistory.invoiceName}>invoice.pdf</Typography>
                      <p style={billingHistory.neutral300}>{dayjs(row.date).format(MMMM_D_YYYY)}</p>
                    </Box>
                  </Box>
                </TableCell>
                <TableCell>
                  <Box sx={billingHistory.tableCell}>
                    <p style={billingHistory.weight700}>{row.billingAdminName}</p>
                    <p style={billingHistory.neutral300}>{row.billingAdminEmail}</p>
                  </Box>
                </TableCell>
                <TableCell>
                  <Box sx={billingHistory.tableCell}>
                    <p style={billingHistory.amount}>{currencyFormatter.format(row.amount)}</p>
                  </Box>
                </TableCell>
                <TableCell>
                  <Box sx={billingHistory.tableCell}>
                    <Box sx={billingHistory.statusWrap(StatusColor[row.status])}>
                      <p className="status">{row.status}</p>
                    </Box>
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default LastTransactions;
